import { createStore } from 'satcheljs';
import type AppDrawerStore from './schema/AppDrawerStore';

const defaultStore: AppDrawerStore = {
    appServiceApps: [],
    hasFetchedAppData: false,
};
export let getStore = createStore<AppDrawerStore>('appDrawerStore', defaultStore);

export default getStore();
